import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PaymentMethod } from "@/api/paymentAPI";
import type { Guest } from "@/types/order";

interface VenuesDataState {
  paidAmount: number;
  paidGuests: Guest[] | undefined;
  remainingAmount: number;
  remainingGuests: Guest[] | undefined;
  totalAmount: number;
  tableNumber: number | null;
  tableId: string | null;
  paymentMethod: string | null;
  selectedAmount: number;
  tipAmount: number;
  blikCode: string;
  splitMethod: PaymentMethod | null;
  selectedDishIds: string[];
  email: string;
  venue: { name: string; websiteText: string; websiteUrl: string } | null;
  /** Basis points added to a tip. See tipFeeGrosze in helpers/cartPricing. */
  tipFeeBps: number;
  color: {
    primary: string;
    secondary: string;
    tertiary: string;
    background: string;
  } | null;
  setVenuesData: (data: Partial<VenuesDataState>) => void;
  reset: () => void;
}

const initialState = {
  paidAmount: 0,
  paidGuests: [],
  remainingAmount: 0,
  remainingGuests: [],
  totalAmount: 0,
  tableNumber: null,
  tableId: null,
  selectedAmount: 0,
  tipAmount: 0,
  paymentMethod: null,
  blikCode: "",
  splitMethod: null,
  selectedDishIds: [],
  email: "",
  venue: null,
  tipFeeBps: 0,
  color: null,
};

export const useVenuesDataStore = create<VenuesDataState>()(
  persist(
    (set) => ({
      ...initialState,
      setVenuesData: (data) => set((state) => ({ ...state, ...data })),
      reset: () => set(initialState),
    }),
    {
      name: "venues-data-store",
      partialize: (state) => ({
        tableId: state.tableId,
        tableNumber: state.tableNumber,
        email: state.email,
        venue: state.venue,
        tipFeeBps: state.tipFeeBps,
        color: state.color,
      }),
    },
  ),
);

/** The venue's tip fee rate, for the screens that must show it before Pay. */
export const useTipFeeBps = () =>
  useVenuesDataStore((state) => state.tipFeeBps);
